import axios from 'axios';

export interface BulkAssignSupraLockboxForSingleUserResult {
  successfulIds: string[];
  failedIds: string[];
  successCount: number;
  failureCount: number;
}

const bulkAssignSupraLockboxForSingleUser = async ({
  userId,
  lockboxIds,
  permissions,
  granteeUserIds = [],
}: {
  userId: string;
  lockboxIds: string[];
  permissions: {
    permissionType: 'owner' | 'assignee';
    ownerOrAssigneeType: 'user' | 'office';
    branchIndex: string | null;
  };
  granteeUserIds?: string[];
}): Promise<BulkAssignSupraLockboxForSingleUserResult> => {
  const { data } = await axios.post<BulkAssignSupraLockboxForSingleUserResult>(
    '/supra/lockbox/bulk_assign_user',
    {
      userId,
      lockboxIds,
      permissions,
      granteeUserIds,
    },
  );

  return data;
};

export default bulkAssignSupraLockboxForSingleUser;
